import type { IFormxRepository, SubmissionCreateInput } from '../repositories/IFormxRepository.js';

interface Deps { formxRepository: IFormxRepository; }

export function createCreateFormxSubmissionUseCase({ formxRepository }: Deps) {
  return async function createFormxSubmission(input: SubmissionCreateInput): Promise<string> {
    return formxRepository.createSubmissionWithValues(input);
  };
}
